import { PopularOption } from '@/entities/map'
import { AdditionalOption, BasicOption, RoomIcon } from '@/entities/room'
import { cn } from '@/shared/lib'

import { ADDITIONAL_OPTIONS, BASIC_OPTIONS, POPULAR_OPTIONS } from './option'
import { FilterType, useFilter } from '../../../model/filter'
import { Title, List, Item, SubTitle } from '../../common/layout'

type Props = {
  type: FilterType
  ref: (element: HTMLDivElement) => void
  className?: string
  selected: (value: PopularOption | BasicOption | AdditionalOption) => boolean
  onChange: ReturnType<typeof useFilter>['updateFilter']
}

export const OptionsInDefaultView = ({
  type,
  ref,
  className,
  selected,
  onChange,
}: Props) => {
  const handlePopularOptionChange = (value: PopularOption) => () => {
    onChange({ popularOptions: value })
  }

  const handleBasicOptionChange = (value: BasicOption) => () => {
    onChange({ basicOptions: value })
  }

  const handleAdditionalOptionChange = (value: AdditionalOption) => () => {
    onChange({ additionalOptions: value })
  }

  return (
    <div className={cn('space-y-3', className)} ref={ref}>
      <Title>옵션</Title>
      <div>
        <SubTitle>인기</SubTitle>
        <List>
          {POPULAR_OPTIONS.map(({ title, value, icon }) => (
            <Item
              key={title}
              type={type}
              selected={selected(value)}
              onClick={handlePopularOptionChange(value)}
              className="flex"
              startIcon={<RoomIcon name={icon} size={20} />}
            >
              <p className="ml-1 flex h-11 items-center justify-center whitespace-break-spaces">
                {title}
              </p>
            </Item>
          ))}
        </List>
      </div>
      <div>
        <SubTitle>기본</SubTitle>
        <List>
          {BASIC_OPTIONS.map(({ title, value, icon }) => (
            <Item
              key={title}
              type={type}
              selected={selected(value)}
              onClick={handleBasicOptionChange(value)}
              className="flex"
              startIcon={<RoomIcon name={icon} size={20} />}
            >
              <p className="ml-1 flex h-11 items-center justify-center whitespace-break-spaces">
                {title}
              </p>
            </Item>
          ))}
        </List>
      </div>
      <div>
        <SubTitle>추가</SubTitle>
        <List>
          {ADDITIONAL_OPTIONS.map(({ title, value, icon }) => (
            <Item
              key={title}
              type={type}
              selected={selected(value)}
              onClick={handleAdditionalOptionChange(value)}
              className="flex"
              startIcon={<RoomIcon name={icon} size={20} />}
            >
              <p className="ml-1 flex h-11 items-center justify-center whitespace-break-spaces">
                {title}
              </p>
            </Item>
          ))}
        </List>
      </div>
    </div>
  )
}
